/**
 * @generated SignedSource<<3eccfa650c5c7eecb8b8d4e690de6ea1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type AssigneeSelectorQuery$variables = {
  query?: string | null;
};
export type AssigneeSelectorQuery$data = {
  readonly selectUsers: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly email: string;
        readonly fullName: string;
        readonly id: string;
        readonly image: string;
        readonly isGuest: boolean;
      };
    }>;
  } | null;
  readonly teams: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly title: string;
      };
    }>;
  } | null;
};
export type AssigneeSelectorQuery = {
  response: AssigneeSelectorQuery$data;
  variables: AssigneeSelectorQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "query"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  {
    "alias": "selectUsers",
    "args": [
      {
        "kind": "Literal",
        "name": "first",
        "value": 15
      },
      {
        "kind": "Literal",
        "name": "isGuests",
        "value": false
      },
      {
        "kind": "Variable",
        "name": "search",
        "variableName": "query"
      }
    ],
    "concreteType": "UserConnection",
    "kind": "LinkedField",
    "name": "users",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "UserEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "email",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "image",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "fullName",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isGuest",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  },
  {
    "alias": null,
    "args": [
      {
        "kind": "Literal",
        "name": "first",
        "value": 10
      },
      {
        "kind": "Variable",
        "name": "query",
        "variableName": "query"
      }
    ],
    "concreteType": "TeamConnection",
    "kind": "LinkedField",
    "name": "teams",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "TeamEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Team",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "title",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AssigneeSelectorQuery",
    "selections": (v2/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AssigneeSelectorQuery",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "7c40a3de6bdd285d9c8740dc09817b55",
    "id": null,
    "metadata": {},
    "name": "AssigneeSelectorQuery",
    "operationKind": "query",
    "text": "query AssigneeSelectorQuery(\n  $query: String\n) {\n  selectUsers: users(first: 15, search: $query, isGuests: false) {\n    edges {\n      node {\n        id\n        email\n        image\n        fullName\n        isGuest\n      }\n    }\n  }\n  teams(first: 10, query: $query) {\n    edges {\n      node {\n        id\n        title\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "41d6327a842932cbb59a39b57e6dd400";

export default node;
